import React from 'react';
import { convertISOToDateFormat } from '../../../util/timezone';
// eg: 17/06/2021, 17:12
export const dateToDDMMYYYYTTMM = (date, fontSize = '11') =>
  date && date !== '-' ? (
    <span style={{ fontSize: `${fontSize}px` }}>
      {new Date(date).toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })}
    </span>
  ) : (
    <span>-</span>
  );

// USE THIS FOR COMPLYING WITH OUR UPDATED TIMEZONE COMPLIANCE!!
export const dateToDDMMYYYYTTMMUniversal = (date, fontSize = '11') =>
  date && date !== '-' ? (
    <span style={{ fontSize: `${fontSize}px` }}>
      {convertISOToDateFormat(date)}
    </span>
  ) : (
    <span>-</span>
  );

// eg: 17/06/2021
export const dateToDDMMYYYY = (date, fontSize = '11') => {
  const [editDate, time] = new Date(date).toLocaleString('en-GB').split(',');
  return (
    date &&
    date !== '-' && (
      <span style={{ fontSize: `${fontSize}px` }}>{editDate} </span>
    )
  );
};

// USE THIS FOR COMPLYING WITH OUR UPDATED TIMEZONE COMPLIANCE!!
export const dateToDDMMYYYYUniversal = (date, fontSize = '11') => {
  const editDate = convertISOToDateFormat(date);
  return (
    date &&
    date !== '-' && (
      <span style={{ fontSize: `${fontSize}px` }}>{editDate} </span>
    )
  );
};

// eg: 1,000,000,000,0
export const no1000Seperator = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
